import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import * as _ from "lodash";
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function checkDisabled(initialData: object, currentData: object) {
  return _.isEqual(initialData, currentData);
}
